import Vue from 'vue'
import axios from 'axios'
Vue.use(axios)
export default {
  sendUserMessage( {dispatch}, obj) {
    return new Promise((resolve, reject) => {
      axios.post('/user/send-message', obj)
        .then(response => {
          resolve(response.data)
        }).catch((err) => {
          reject(err)
        })
    })
  }, 
  deleteMessageByDate( {dispatch}, obj) {
    return new Promise((resolve, reject) => {
      axios.post('/user/delete-message-by-date', obj)
        .then(response => {
          console.log(response)
          resolve(response.data)
        }).catch((err) => {
          reject(err)
        })
    })
  }, 
}
